<template>
    <main class="main">
        <div class="container">
            <div class="o-productEans">
                <div class="row">
                    <!-- Filters -->
                    <div class="col-lg-3 d-flex flex-column">
                        <the-filters
                            @applyFilters="applyFilters"
                            :filters="filters"
                            module-name="altEans"
                            subtitle="Pokaż produkty"
                        />
                    </div>

                    <div class="col-lg-9">
                        <h2 class="promo-heading pb-4">
                            <div
                                class="w-100 d-flex justify-content-between
                                align-items-center gap-1 position-relative flex-wrap"
                            >
                                <span>Kody lokalne</span>

                                <div class="d-flex gap-0-5">
                                    <the-btn
                                        id="tutorial-alt-eans"
                                        class="btn-sm btn-secondary"
                                        @click.native="launchWalkthrough"
                                    >
                                        <a-icon
                                            icon="Bulb"
                                            class="mr-1"
                                            :style="'width: 16px; height: 16px'"
                                        />
                                        Samouczek
                                    </the-btn>

                                    <the-btn
                                        @click.native="openModalProducts"
                                        class="add-product btn-sm btn-secondary"
                                    >
                                        <a-icon
                                            icon="Plus"
                                            class="mr-1"
                                            :style="'width: 16px; height: 16px'"
                                        />
                                        Dodaj produkt
                                    </the-btn>
                                </div>
                            </div>
                        </h2>

                        <div
                            class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-3"
                        >
                            Dodaj do bazy wybrane produkty oraz zadeklaruj kody
                            lokalne dla poszczególnych sklepów. Kody będą
                            podpowiadane podczas aktywacji promocji na dane
                            produkty oraz przy tworzeniu promocji własnych
                        </div>

                        <selected-filters
                            class="mb-4"
                            :filters="filters"
                            module-name="altEans"
                            @applyFilters="applyFilters"
                        />

                        <page-preloader v-if="status === 'loading'" />

                        <div
                            v-else-if="
                                pagination && +pagination.totalRecords > 0
                            "
                            class="c-table table-product-eans"
                            :class="isOneShopSelected ? '--one-shop' : ''"
                        >
                            <div class="c-thead gap-1">
                                <div class="c-td is-1">Zdjęcie</div>
                                <div class="c-td is-2">Nazwa produktu</div>
                                <div class="c-td is-3">Typ produktu</div>
                                <div class="c-td is-3">Kod EAN</div>
                                <div class="c-td is-4">Kod lokalny</div>
                            </div>

                            <div class="c-tbody">
                                <div
                                    class="c-row"
                                    v-for="product in products"
                                    :key="product.id"
                                >
                                    <div class="c-tr gap-1">
                                        <div class="c-td is-1">
                                            <img
                                                v-if="product.image"
                                                :src="product.image.urls.small"
                                                class="img-fluid"
                                            />
                                            <a-icon v-else icon="NoPhoto" />
                                        </div>

                                        <div class="c-td is-2 font-weight-bold">
                                            <p class="mb-0">
                                                {{ product.name }}
                                            </p>
                                            <span
                                                class="d-block d-lg-none typo--sm typo--gray typo--semi"
                                            >
                                                Typ: {{ setProductTypeLabel(product.available_in_promos) }}
                                            </span>
                                            <span
                                                class="d-block d-lg-none typo--sm typo--gray typo--semi"
                                            >
                                                EAN: {{ product.ean }}
                                            </span>
                                        </div>

                                        <div
                                            class="c-td is-3"
                                            v-text="setProductTypeLabel(product.available_in_promos)"
                                        />

                                        <div
                                            class="c-td is-3"
                                            v-text="product.ean"
                                        />

                                        <div class="c-td is-4">
                                            <div
                                                class="d-flex gap-0-5"
                                                v-if="isOneShopSelected"
                                            >
                                                <the-input
                                                    class="mb-0"
                                                    :text="
                                                        product
                                                            .alternative_eans[0]
                                                            .alternative_ean
                                                    "
                                                    @input="
                                                        product.alternative_eans[0].alternative_ean = $event
                                                        checkIfEansExist(
                                                            product
                                                        )
                                                    "
                                                    validation="localCode"
                                                    :disabled="
                                                        isProductDisabled(
                                                            product
                                                        )
                                                    "
                                                />

                                                <!-- Save btn -->
                                                <the-btn
                                                    @click.native="
                                                        saveEan(product)
                                                    "
                                                    :disabled="
                                                        saveBtnDisabled(product)
                                                    "
                                                    class="btn-sm"
                                                >
                                                    <a-icon
                                                        width="22"
                                                        height="22"
                                                        :icon="
                                                            savingId ===
                                                                product.id
                                                                ? 'Spinner'
                                                                : 'Save'
                                                        "
                                                    />
                                                </the-btn>

                                                <!-- Remove btn -->
                                                <v-popover
                                                    class="remove-popover"
                                                    offset="8"
                                                >
                                                    <the-btn
                                                        class="btn-sm btn-danger"
                                                        :disabled="
                                                            isProductDisabled(
                                                                product
                                                            )
                                                        "
                                                    >
                                                        <a-icon
                                                            width="16"
                                                            height="16"
                                                            :icon="
                                                                deletingId ===
                                                                    product.id
                                                                    ? 'Spinner'
                                                                    : 'Bin'
                                                            "
                                                        />
                                                    </the-btn>

                                                    <template slot="popover">
                                                        <popover-confirm
                                                            message="Usunąć?"
                                                            confirm-text="Potwierdź"
                                                            @confirmed="
                                                                removeEan(
                                                                    product
                                                                )
                                                            "
                                                        />
                                                    </template>
                                                </v-popover>
                                            </div>
                                            <the-btn
                                                :counter="
                                                    product.alternative_eans
                                                        .length
                                                "
                                                @click.native="
                                                    openModalAlternativeEans(
                                                        product
                                                    )
                                                "
                                                v-else
                                            >
                                                Dostosuj
                                            </the-btn>
                                        </div>
                                    </div>
                                    <div
                                        class="text-danger text-right px-3 pb-2"
                                        style="margin-top: -0.5rem"
                                        v-if="existingCode(product)"
                                    >
                                        Kod został już zapisany dla produktu
                                        {{ existingCode(product).name }} (EAN:
                                        {{ existingCode(product).ean }})
                                    </div>
                                </div>
                            </div>

                            <the-pagination
                                class="mt-3"
                                :pagination="pagination"
                                @change="setPagination"
                            />
                        </div>

                        <info-message
                            v-else-if="!areAltEansFiltersApplied"
                            :text="noProductsText"
                            btn-text="Dodaj produkt"
                            btn-icon="Plus"
                            @click="openModalProducts"
                        />

                        <div v-else>Brak wyników</div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { tour } from '@/walkthroughs/altEans'
import InfoMessage from '../components/global/ui/InfoMessage'
export default {
    name: 'ProductEans',
    components: { InfoMessage },
    data() {
        return {
            codesChanged: false,
            savingId: null,
            deletingId: null,
            initialState: [],
            errors: []
        }
    },

    computed: {
        filters() {
            return this.$store.getters.getAltEansFilters
        },

        selectedShops() {
            return this.filters.merchant_id.value
        },

        status() {
            return this.$store.getters.getAltEansStatus
        },

        products() {
            return this.$store.getters.getAltEans
        },

        pagination() {
            return this.$store.getters.getAltEansPagination
        },

        isOneShopSelected() {
            return (
                this.$store.getters.getPromoMerchantsForSelect.length === 1 ||
                this.selectedShops.length === 1
            )
        },

        changedCodes() {
            const { initialState, products } = this
            if (!initialState) return []

            return products
                .filter(pEan => {
                    const initEan = initialState.find(
                        iEan => iEan.id === pEan.id
                    )

                    return (
                        initEan?.alternative_eans[0].alternative_ean !==
                        pEan.alternative_eans[0].alternative_ean
                    )
                })
                .map(product => {
                    return product.alternative_eans[0]
                })
        },
        noProductsText() {
            return 'Twoja baza towarów wagowych jest pusta. <br/>Aby dodać pierwszy produkt i uzupełnić jego kod lokalny, kliknij "Dodaj produkt"'
        },
        areAltEansFiltersApplied() {
            return this.$store.getters.areAltEansFiltersApplied
        }
    },

    methods: {
        async fetch(params) {
            await this.$store.dispatch('loadAltEans', params)
        },

        async setPagination(page) {
            const top = document.querySelector('.table-product-eans')
            const headerHeight = document.querySelector('.site-header')
                .clientHeight
            this.$scrollTo(top, 100, {
                offset: -headerHeight
            })
            await this.fetch({ page })
            this.setInitState()
        },

        async applyFilters() {
            await this.fetch()
            this.errors = []
            this.setInitState()
        },

        openModalAlternativeEans(product) {
            this.$store.dispatch('openModal', {
                component: 'AlternativeEans',
                args: {
                    dictProduct: product
                }
            })
        },

        openModalProducts() {
            this.$store.dispatch('openModal', {
                component: 'MerchantEanSelectionProducts',
                args: {
                    params: {
                        main: true,
                        per: 50,
                        ean_present: false,
                        sort: 'name'
                    }
                }
            })
        },

        resetSingleEanInitState(id, action) {
            const product = this.products.find(p => p.id === id)
            const index = this.initialState.findIndex(p => p.id === id)

            if (index === -1) {
                return
            }

            if (action === 'update') {
                this.initialState[index].alternative_eans[0].alternative_ean =
                    product.alternative_eans[0].alternative_ean
            } else {
                // remove product from initialState
                this.initialState = this.initialState.filter(p => p.id !== id)
            }
        },

        async saveEan({ alternative_eans, id }) {
            if (this.savingId) return

            this.savingId = id
            const res = await this.$store.dispatch('updateAltEan', {
                id: alternative_eans[0].id,
                alternative_ean: alternative_eans[0].alternative_ean
            })

            if (res.status === 200) {
                this.resetSingleEanInitState(id, 'update')

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zapisano'
                })
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas zapisywania'
                })
            }

            this.savingId = null
        },

        async removeEan({ id, alternative_eans }) {
            if (this.deletingId) return

            this.deletingId = id
            const res = await this.$store.dispatch(
                'deleteAltEan',
                alternative_eans[0].id
            )

            if (res.status === 200) {
                this.resetSingleEanInitState(id, 'delete')

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Usunięto'
                })
                this.$store.dispatch('removeEanFromStore', id)
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas usuwania'
                })
            }

            this.deletingId = null
        },

        isProductDisabled(product) {
            return (
                this.deletingId === product.id || this.savingId === product.id
            )
        },

        existingCode(product) {
            const altEan = product.alternative_eans[0]

            return this.errors.find(
                error =>
                    error.alternative_ean === altEan.alternative_ean &&
                    error.id !== altEan.id
            )
        },

        setInitState() {
            this.initialState = JSON.parse(JSON.stringify(this.products))
        },

        async checkIfEansExist() {
            this.errors = await this.$store.dispatch(
                'checkIfEansExist',
                this.changedCodes
            )
        },

        saveBtnDisabled(product) {
            const altEan = product.alternative_eans[0]

            return (
                this.errors.findIndex(
                    e => e.alternative_ean === altEan.alternative_ean
                ) > -1 ||
                this.changedCodes.findIndex(e => e.id === altEan.id) === -1 ||
                this.isProductDisabled(product) ||
                !product.alternative_eans[0].alternative_ean
            )
        },

        launchWalkthrough() {
            tour.start()
        },
        setProductTypeLabel(availableInPromos) {
            switch (availableInPromos) {
            case 'weight':
                return 'wagowy'
            case 'piece':
                return 'sztukowy'
            default:
                return '-'
            }
        }
    },

    async created() {
        await this.fetch()
        this.setInitState()
    }
}
</script>
